<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-terminated',
    }"
  >
    <h4 class="mt-6 mb-9">
      {{ companyName || 'Your company' }} isn't eligible for a Datapeople account.
    </h4>
    <p class="p3">
      Hi {{ firstName }}! Thanks for your interest in Datapeople. We're unable to
      support your organization at this time, but we've taken note of
      {{ companyName || 'your company' }} and will reach out if that changes.
      Good luck with your product research!
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'TerminatedGeneric',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName', 'companyName']),
  },
  created() {
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-873652164/n88iCLvajNQBEMS_y6AD' });
    }
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Terminated Generic' });
  },
};
</script>
